export const LogoImage = require("../assets/images/ecos_Logo_Stuttgart_CMYK.png");
